// extracted by mini-css-extract-plugin
export default {"message_container":"ErrorBoundary_message_container__N5xqa","text":"ErrorBoundary_text__9XVsg"};